export default __webpack_public_path__ + "static/media/parks-large.7fbb0acb.svg";